<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2022-05-17 14:15:42
 * @LastEditors: wangwang 2723008256@qq.com
 * @LastEditTime: 2022-05-17 14:34:38
 * @FilePath: \jzjypc4.0\src\views\PersonalCenter\MyData\AllData\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="container">学校产品数据</div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped></style>
